import { default as CheckboxMaterialUI } from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import React, { Component } from 'react';
import styled from 'styled-components';
import theme from '@lib/theme';
import { TypographyCheckbox } from './../Label';
import Label from './Label';

const Wrapper = styled.div``;

const styles = {
  root: {
    position: 'relative',
    /* when checked margin is added which makes elements move a little bit, so we force it here */
    margin: '0 10px 0 0',
    color: '#eeeeee',
    width: '15px',
    marginRight: '7px',
    height: '100%',
    '&$checked': {
      color: theme.colors.primary['blue-2'],
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  checked: {},
  sizeIcon: {
    fontSize: 20,
  },
};

class Checkbox extends Component {
  state = {
    isChecked: false,
  };

  handleChange = e => {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(e);
    }
  };

  static getDerivedStateFromProps(props) {
    return {
      isChecked: props.isChecked,
    };
  }

  render() {
    const {
      'data-testid': dataTestId = 'Checkbox',
      className,
      required = false,
    } = this.props;
    if (this.props.label) {
      return (
        <Wrapper
          className={className}
          style={this.props.style}
          data-testid={dataTestId}
        >
          <Label label={this.props.label}>
            <CheckboxMaterialUI
              checked={this.props.isChecked}
              onChange={this.handleChange}
              classes={{
                root: this.props.classes.root,
                checked: this.props.classes.checked,
              }}
              icon={
                <CheckBoxOutlineBlankIcon
                  className={this.props.classes.sizeIcon}
                />
              }
              checkedIcon={
                <CheckBoxIcon className={this.props.classes.sizeIcon} />
              }
              required={required}
            />
          </Label>
        </Wrapper>
      );
    } else {
      return (
        <Wrapper
          className={className}
          style={this.props.style}
          data-testid={dataTestId}
        >
          <Label
            label={
              <TypographyCheckbox labelColor={this.props.labelColor}>
                {this.props.children}
              </TypographyCheckbox>
            }
          >
            <CheckboxMaterialUI
              name={this.props.name}
              htmlFor={this.props.htmlFor}
              id={this.props.id}
              checked={this.props.isChecked}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              classes={{
                root: this.props.classes.root,
                checked: this.props.classes.checked,
              }}
              icon={
                <CheckBoxOutlineBlankIcon
                  className={this.props.classes.sizeIcon}
                />
              }
              checkedIcon={
                <CheckBoxIcon className={this.props.classes.sizeIcon} />
              }
              required={required}
            />
          </Label>
        </Wrapper>
      );
    }
  }
}

export default withStyles(styles)(Checkbox);
